import { State } from "@progress/kendo-data-query";

// eslint-disable-next-line no-extend-native
Array.prototype.paged = function (dataState: State) {
  const skip: number = dataState?.skip ?? 0;
  const take: number = dataState?.take ?? 0;
  return this.slice(skip, take + skip);
};

export {};
